import { NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react";

import { useEditorContext } from "../EditorContext";
import type { RenderMentionArgs } from "../editorTypes";
import type { MentionAttrs } from "../extensions/mention";

export const MentionNodeView = ({ node, editor }: ReactNodeViewProps) => {
  const { settings } = useEditorContext();
  const { id, label, name, href } = node.attrs as MentionAttrs;
  const kind = name ?? "";
  const displayLabel = label ?? id ?? "";

  const args: RenderMentionArgs = {
    kind,
    id: id ?? "",
    label: label ?? undefined,
    attrs: node.attrs as Record<string, unknown>,
  };

  const rendered =
    !editor.isEditable && kind && id && settings.renderMention
      ? settings.renderMention(args)
      : null;

  // A rendered user chip carries its own click behaviour, every other mention keeps its link.
  const linkHref =
    rendered && kind === "users" ? undefined : (href ?? `/${kind}/${id}`);

  return (
    <NodeViewWrapper
      as="a"
      className={kind ? `mention mention-${kind}` : "mention"}
      contentEditable={false}
      data-mention-atom-id={id ?? ""}
      data-mention-atom-name={kind}
      href={linkHref}
    >
      <span style={{ display: "inline-flex", alignItems: "center" }}>
        {rendered ?? displayLabel}
      </span>
    </NodeViewWrapper>
  );
};
